import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { DefaultValueConstants } from '../../constants/default-value-constants';


@Component({
  selector: 'app-tree',
  templateUrl: './tree.component.html',
  styleUrls: ['./tree.component.scss']
})
export class TreeComponent implements OnInit {
  @Input()
  treeData: TreeNode[] = [];
  @Input()
  selectionMode: string = DefaultValueConstants.Default_Tree_Selection_Mode;
  @Output() onNodeSelection: EventEmitter<any> = new EventEmitter();
  @Output() onNodeUnselection: EventEmitter<any> = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }
  nodeSelect = (event: any) => {
    this.onNodeSelection.emit(event);
  }
  nodeUnselect = (event: any) => {
    this.onNodeUnselection.emit(event);
  }

}
